export default "__VITE_ASSET__DjJZjjQ$__"